<template>
  <div class="mall-tag">
    <slot name="logo">
      <v-avatar v-if="tile === true" :width="size" :height="height" tile>
        <img
          :src="logoSrc"
          @error="$event.target.src = mall.logo404Path"
          :alt="`${mall.name} 로고`"
        />
      </v-avatar>

      <v-avatar v-else :size="size">
        <img
          :src="logoSrc"
          @error="$event.target.src = mall.logo404Path"
          :alt="`${mall.name} 로고`"
        />
      </v-avatar>
    </slot>

    <slot>
      <span class="font--m-4 ml-3">{{ mall.name }}</span>
    </slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    providerCode: {
      type: String,
      required: true,
      default: null,
    },
    size: {
      type: Number,
      default: 30,
    },
    height: {
      type: Number,
      default: 35,
    },
    tile: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('mall', ['providersObj']),
    mall() {
      const mall = this.providersObj[this.providerCode]
      if (!!mall) {
        return mall
      } else {
        return {
          logo: null,
          logo404Path: null,
          name: this.providerCode,
        }
      }
    },
    logoSrc() {
      if (this.white === true) {
        return this.mall.logoWhite
      }

      const src = this.tile === true ? this.mall.logoRectangle : this.mall.logo
      return !!src ? src : this.mall.logo404Path
    },
  },
}
</script>

<style lang="scss" scoped>
.mall-tag {
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
    vertical-align: middle;
  }

  span {
    color: inherit;
  }
}
</style>
